import { IconLinkProps } from "@whitespace/whitespace-ui/dist/components/IconLink/IconLink";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./HwrcIconLink.scss";

const HwrcIconLink = ({
  iconClass,
  iconLink,
  iconDescription,
  iconComponent
}: IconLinkProps) => {
  const containerClassName = `hwrc-icon-link ${iconClass}`;
  return (
    <Link to={iconLink} data-testid={`${iconClass}-link`}>
      <Row data-testid="icon-link" className={containerClassName}>
        <Col xs={4} md={5} className="icon-container">
          {iconComponent}
        </Col>
        <Col xs={6} md={7}>
          <div className="description">{iconDescription}</div>
        </Col>
      </Row>
    </Link>
  );
};

export default HwrcIconLink;
